export enum ExpirationType {
  TIME_UNIT = 'TIME',
  SPECIFIC_DATE = 'DATE',
}
